/*
	支払方法管理画面
	定期購読支払情報　一覧表示画面
*/

import React, { memo } from 'react';
import classes from './subscription-list-table-detail.module.scss';
import { Hr } from 'components/atoms/Hr';
import { PeriodicPaymentToken } from 'requests/RequestPeriodicPayment';

type Props = {
	headerTitle: string;
	tableColumnList: string[];
	tableKeyList: string[];
	periodicPaymentList: PeriodicPaymentToken[];
	onClickEvent: (index: number) => void;
};
export const SubscriptionListTableDetail = memo((props: Props) => {
	const { headerTitle, tableColumnList, tableKeyList, periodicPaymentList, onClickEvent } = props;

	const isInvalidDate = (date: Date) => {
		return Number.isNaN(date.getTime());
	};

	return (
		<div className="section-in" style={{ marginTop: 50 }}>
			<div className="section-head">
				<span className={classes.sectionHeadH1}>{headerTitle}</span>
			</div>
			<div className="info-box form-box">
				<div className="form-input">
					<div className="info-box">
						<div className={classes.subscriptionRowHead}>
							{tableColumnList.map((column) => {
								return <div className={'info-head ' + classes.subscriptionRowHeadCol}>{column}</div>;
							})}
							<div className={'info-head ' + classes.subscriptionRowHeadCol} />
						</div>
						<Hr />
						{periodicPaymentList?.map((t, i) => {
							return (
								<>
									<div className={classes.subscriptionRow}>
										<div className="radio-box">
											<ul>
												<li className={classes.subscriptionLi}>
													{tableKeyList.map((key) => {
														return (
															<div className={classes.subscriptionCol}>
																{t[key] instanceof Date
																	? !isInvalidDate(t[key])
																		? t[key].toLocaleDateString()
																		: ''
																	: t[key]}
															</div>
														);
													})}
													<div
														className={`${classes.subscriptionCol} ${classes.showInfoLink}`}
														onClick={() => onClickEvent(i)}
													>
														<span className={classes.linkToMemberInfo}>&gt;</span>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
});
